export const LANGUES_45 = [
  "Français","English","Español","Português","Deutsch","Italiano","Nederlands",
  "Polski","Русский","Türkçe","Arabe","日本語","한국어","中文","हिन्दी",
  "Bahasa Indonesia","Bahasa Melayu","Tiếng Việt","ภาษาไทย","Română",
  "Čeština","Magyar","Slovenčina","Українська","Ελληνικά","Suomi",
  "Svenska","Norsk","Dansk","Català","فارسی","עברית","বাংলা",
  "اردو","தமிழ்","తెలుగు","मराठी","Hausa","Swahili","Wolof",
  "Shimaoré 🇾🇹","Kibushi 🇾🇹","Malagasy","Créole Réunion","Lingala"
];

export interface UserProfile {
  uid: string;
  email: string;
  name: string;
  plan: 'free' | 'pro' | 'agency';
  quotaUsed: number;
  quotaMax: number;
  isAdmin: boolean;
  isUnlimited: boolean;
  createdAt: string;
}
